import appStore from 'store';
import api from './api';
import { PAGINATION } from './constants';

const store = {
  namespaced: true,
  state: {
    auditList: [],
    activeTab: 'unaudited',
    detailDialogVisible: false,
    auditDetail: {},
    pagination: PAGINATION,
    totalCount: 0,
    coinList:[]
  },
  mutations: {
    setAuditList(state, payload) {
      state.auditList = payload.list;
      state.totalCount = payload.totalCount;
    },
    setpage(state, page) {
      state.pagination = page;
    },
    setCoinList(state, payload) {
      state.coinList = payload;
    },
  },
  actions: {
    gethashList({ commit }, query) {
      api.gethashList(query).then(({ data }) => {
        commit('setAuditList', data);
      });
    },
    getCoinList({ commit }, query) {
      api.getAllCoins(query).then(({ data }) => {
        commit('setCoinList', data);
      });
    },
  }
};

appStore.registerModule('depositeRecord', store);
